import { render, staticRenderFns } from "./virtualUser.vue?vue&type=template&id=c10aef14&scoped=true&"
import script from "./virtualUser.vue?vue&type=script&lang=js&"
export * from "./virtualUser.vue?vue&type=script&lang=js&"
import style0 from "./virtualUser.vue?vue&type=style&index=0&id=c10aef14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10aef14",
  null
  
)

export default component.exports